/** W82: Lesetext des Abzeichens am Reiter (TabPille.tsx). */
/** Lesetext des Abzeichens wie iOS (AppModell.swift): „2 zu prüfen, 1 überfällig“, Teile ohne Null. */
export function abzeichenText(a: { pruefen: number; ueberfaellig: number }): string {
  return [a.pruefen ? `${a.pruefen} zu prüfen` : "", a.ueberfaellig ? `${a.ueberfaellig} überfällig` : ""].filter(Boolean).join(", ");
}

